import GenericTopPostsDrawer from './GenericTopPostsDrawer';
import { getBrandOnlyTopPosts } from 'utils/api/instagram.api';

const BrandNoCatTopPostsDrawer = ({
    year,
    week,
    brands,
    countries,
    name,
    displayQty,
}) => {
    const queryParams = {
        brand: brands || null,
        country: countries || null,
        page: 1,
        per_page: 500,
    };

    return (
        <GenericTopPostsDrawer
            year={year}
            week={week}
            name={name}
            displayQty={displayQty}
            queryFn={getBrandOnlyTopPosts}
            queryParams={queryParams}
        />
    );
};

export default BrandNoCatTopPostsDrawer;
